import { render, staticRenderFns } from "./ElectLabel.vue?vue&type=template&id=daa7f350&"
import script from "./ElectLabel.vue?vue&type=script&lang=js&"
export * from "./ElectLabel.vue?vue&type=script&lang=js&"
import style0 from "./ElectLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports